export default __webpack_public_path__ + "static/Refrigerator-5a1d2c04156b7e4e2fdfeb3f09399201.png";